<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1868_648)">
      <path
        d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888
         36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
        fill="#EEF1F4"
      />
      <path
        d="M30.3161 36.0001V32.8422C30.3161 31.1671 29.6674 29.5607
         28.5125 28.3762C27.3577 27.1918 25.7914 26.5264 24.1583
          26.5264H11.8425C10.2093 26.5264 8.643 27.1918 7.48818
           28.3762C6.33335 29.5607 5.68457 31.1671 5.68457 32.8422V36.0001"
        fill="#1F9AFF"
      />
      <path
        d="M18.0004 20.8422C21.4013 20.8422 24.1583 18.0852
         24.1583 14.6843C24.1583 11.2834 21.4013 8.52637 18.0004
          8.52637C14.5994 8.52637 11.8425 11.2834 11.8425 14.6843C11.8425 18.0852 14.5994 20.8422 18.0004 20.8422Z"
        fill="#1F9AFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1868_648">
        <path
          d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36
           8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts">
</script>